import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CriticalPathOptimizerService {
  private platformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.platformId);

  /**
   * Initializes performance monitoring for the application's critical rendering path.
   * The primary optimization logic has been moved to index.html for maximum performance.
   */
  public initializeMonitoring(): void {
    if (!this.isBrowser) return;
    this.monitorCriticalPath();
  }

  /**
   * Monitor critical path performance (LCP and FCP) and log warnings if they exceed thresholds.
   */
  private monitorCriticalPath(): void {
    // Monitor LCP (Largest Contentful Paint)
    const lcpObserver = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      const lastEntry = entries[entries.length - 1];

      if (lastEntry.entryType === 'largest-contentful-paint') {
        console.log(`LCP: ${lastEntry.startTime.toFixed(2)}ms`);

        if (lastEntry.startTime > 2500) {
          console.warn('LCP is too slow (>2.5s)');
        }
      }
    });
    lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });

    // Monitor FCP (First Contentful Paint)
    const fcpObserver = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      const lastEntry = entries[entries.length - 1];

      if (lastEntry.entryType === 'first-contentful-paint') {
        console.log(`FCP: ${lastEntry.startTime.toFixed(2)}ms`);

        if (lastEntry.startTime > 1800) {
          console.warn('FCP is too slow (>1.8s)');
        }
      }
    });
    fcpObserver.observe({ entryTypes: ['first-contentful-paint'] });
  }
}
